// USA
import lang from '../../../../assets/i18n/en.json';
import { LanguageType } from './language-type.model';

export const locale = {
  lang: LanguageType.English,
  data: lang
};
